export default {
  install(_Vue, { router, enabled = true }) {
    if (!enabled || !router) return;

    const loadClarity = (id) => {
      if (!id) return;

      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)
      })(window, document, "clarity", "script", id);
    };

    const initClarity = (url) => {
      if (url.includes("/GridSolicitacaoCotacao")) {
        loadClarity(process.env.VUE_APP_CLARITY_ID_CORRETOR); // CORRETOR
      } else if (url.includes("/GridPrincipal")) {
        loadClarity(process.env.VUE_APP_CLARITY_ID_ANALISTA); // ANALISTA
      }
    };

    initClarity(window.location.href);

    router.afterEach((to) => {
      const fullPath = window.location.origin + to.fullPath;
      initClarity(fullPath);
    });
  }
};



// WEBPACK FOOTER //
// ./src/plugins/clarity.js